export default __webpack_public_path__ + "static/media/imagotype_white.2bccc21c.svg";